module.exports = __webpack_public_path__ + "img/tech.3c462f3.png";